module.exports = __webpack_public_path__ + "img/icon-doctor.b3bc0d63.png";